import { render, staticRenderFns } from "./NoticeInfo.vue?vue&type=template&id=396ffb1a&scoped=true"
import script from "./NoticeInfo.vue?vue&type=script&lang=ts"
export * from "./NoticeInfo.vue?vue&type=script&lang=ts"
import style0 from "./NoticeInfo.vue?vue&type=style&index=0&id=396ffb1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396ffb1a",
  null
  
)

export default component.exports